import { render, staticRenderFns } from "./clientdashboard-profile-message.vue?vue&type=template&id=efd5e84c&"
import script from "./clientdashboard-profile-message.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-profile-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports